<template>
    <div class="content-box">
        <div class="element-wrapper">
            <div class="element-box">
                <div class="center">
                    <h5 text-align="center">Agendar Nuevo Evento <i class="fas fa-calendar"></i></h5>
                </div>
                <br>
                <label>Tipo Evento:</label>
                <br>
                <select name="select-evento-tipo" class="select-size">
                    <option value="recp" selected>Recepción</option>
                    <option value="cita">Cita</option>
                </select>
                <br>
                <div class="item">
                    <ProveedoresSelectComponent class="item" :current="current" />
                </div>
                <div>
                    <label>Fecha y Hora:</label>
                    <div class="form-inline">
                        <datepicker :format="'dd/MM/yyyy'"></datepicker>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <input class="time-size" type="time" id="time-select" name="time" min="09:00" max="18:00"
                            required>
                    </div>
                    <label>Status:</label>
                    <br>
                    <select name="select-estatus" class="select-size">
                        <option value="age" selected>Agendado</option>
                        <option value="can">Cancelado</option>
                    </select>
                    <br>
                    <label>Observaciones:</label>
                    <br>
                    <input class="select-size" type="text" id="input-observaciones" autocomplete="off"><br><br>
                    <br>
                    <div class="form-inline justify-content-sm-end center" style="position: center;">
                        <router-link class="btn btn-danger" :to="{ name: 'wms-agenda' }">
                            <i class="fas fa-arrow-left	"></i>
                            Cancelar
                        </router-link>
                        <button @click="guardar()" class="btn btn-success" disabled>
                            Guardar Cambios
                            <i class="fas fa-check"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";

export default {
    components: {
        ProveedoresSelectComponent
    },

    data() {
        return {
            current: {},
        }
    },

    methods: {
        guardar() {
            let self = this;
        }
    }
}
</script>
<style>
.center {
    margin-left: 40px;
    margin-top: 10px;
}

.select-size {
    width: 345px;
    height: 24px;
}

.time-size {
    width: 115px;
    height: 24px;
}

.item {
    display: inline;
    width: 100%;
    height: 24px;
}
</style>